import React, { useState, useEffect, useContext } from 'react';
import { useTheme } from '@material-ui/styles';
import { useStyles } from '../styles';

import { Typography } from '@material-ui/core';

import Crud from '../crud';
import Quickcrumbs from '../../global/Quickcrumbs';


const ControllerTypes = props => {


    const theme = useTheme();
    const styles = useStyles(theme);

    return (
        <div className={styles.root}>
            <div className={styles.wrapper}>

                <Quickcrumbs 
                    crumbs={[
                        {
                            name: 'Settings',
                            route: '/settings'
                        },
                        {
                            name: 'Controller Types',
                            route: '/settings/controller_types'
                        }
                    ]}
                    history={props.history}
                />

                <div className={styles.taskbar}>

                    <Typography variant="h4">Controller Types</Typography>

                </div>
                
                <Typography color="textSecondary" variant="caption" className={styles.space}>A categorization of controller types used to preset charge points with settings.</Typography>

                <Crud
                    heading='Controller Types'
                    uri='controller_types'
                    idCol='id_controller_type'
                    displayColumns={[
                        { 
                            name: 'controller_type_name', 
                            type: 'string',
                            editable: true,
                            required: true
                        }
                    ]}
                />

            </div>

        </div>
    )

}

export default ControllerTypes
